/**
 * barnaby-theme.js
 * Vanilla JS for Barnaby Bright Shopify theme.
 * No jQuery, no framework. Keyboard accessible, reduced-motion safe.
 */

(function () {
  'use strict';

  /* ─────────────────────────────────────────────
   * 1. SCROLL REVEAL
   * Uses IntersectionObserver; no duplicate smooth-scroll.
   * ──────────────────────────────────────────── */
  function initReveal() {
    const els = document.querySelectorAll('.bb-reveal, .bb-stagger > *');
    if (!els.length) return;

    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function (el, i) {
      if (el.closest('.bb-stagger')) {
        el.style.transitionDelay = (i % 6) * 80 + 'ms';
      }
      observer.observe(el);
    });
  }

  /* ─────────────────────────────────────────────
   * 2. FEELING FINDER
   * Chip selection → filter visible books.
   * ──────────────────────────────────────────── */
  function initFeelingFinder() {
    const finder = document.querySelector('.bb-feeling-finder');
    if (!finder) return;

    const chips = finder.querySelectorAll('.bb-feeling-chip');
    const grid  = finder.querySelector('.bb-finder-grid');
    if (!grid) return;

    chips.forEach(function (chip) {
      chip.setAttribute('role', 'button');
      chip.setAttribute('tabindex', '0');

      function activate() {
        const emotion = chip.dataset.emotion;

        // Toggle selection
        const wasActive = chip.classList.contains('is-active');
        chips.forEach(function (c) {
          c.classList.remove('is-active');
          c.setAttribute('aria-pressed', 'false');
        });

        if (!wasActive) {
          chip.classList.add('is-active');
          chip.setAttribute('aria-pressed', 'true');
          filterBooks(emotion, grid);
        } else {
          filterBooks(null, grid);
        }
      }

      chip.addEventListener('click', activate);
      chip.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(); }
      });
    });
  }

  function filterBooks(emotion, grid) {
    const finder = grid.closest('.bb-feeling-finder');
    const cards = grid.querySelectorAll('.bb-product-card');
    cards.forEach(function (card) {
      var emotions = (card.dataset.emotions || '').split(',').map(function (s) { return s.trim(); });
      if (!emotion || emotions.indexOf(emotion) !== -1) {
        card.style.display = '';
        card.removeAttribute('hidden');
      } else {
        card.style.display = 'none';
        card.setAttribute('hidden', '');
      }
    });

    // Count visible books
    var visible = grid.querySelectorAll('.bb-product-card:not([style*="none"])').length;

    // Update live count announcement
    var countEl = finder ? finder.querySelector('.bb-finder-count') : null;
    if (countEl) countEl.textContent = emotion ? visible + ' book' + (visible !== 1 ? 's' : '') + ' match this feeling' : '';

    // Show/hide empty state
    var emptyEl = finder ? finder.querySelector('.bb-finder-empty') : null;
    if (emptyEl) emptyEl.hidden = !emotion || visible > 0;
  }

  /* ─────────────────────────────────────────────
   * 3. HEADER SCROLL STATE
   * Adds .is-scrolled to sticky header for shadow.
   * ──────────────────────────────────────────── */
  function initHeaderScroll() {
    var header = document.querySelector('.bb-header');
    if (!header) return;
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-scrolled', window.scrollY > 40);
    }, { passive: true });
  }

  /* ─────────────────────────────────────────────
   * 4. BARNABY WAVE INTERACTION
   * Click the wave hand → small animation burst.
   * ──────────────────────────────────────────── */
  function initBarnabWave() {
    var wave = document.querySelector('.bb-wave');
    if (!wave) return;
    wave.addEventListener('click', function () {
      wave.classList.add('is-waving');
      setTimeout(function () { wave.classList.remove('is-waving'); }, 800);
    });
  }

  /* ─────────────────────────────────────────────
   * INIT
   * ──────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initFeelingFinder();
    initHeaderScroll();
    initBarnabWave();
  });

})();
